export default "__VITE_ASSET__ClkSOkXG__"